import { ref } from 'vue';

export function debounce(fn, debounceMs = 500){
  const timeoutId = ref(null);

  return (...args)=>{
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
      timeoutId.value = null
    }
    timeoutId.value = setTimeout(()=>{
      timeoutId.value = null;
      fn(...args);
    }, debounceMs);
  }
}